import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmpresaItem, GrupoEmpresa } from '../models/grupos-empresa.models';
import { GruposEmpresaService } from '../services/grupos-empresa.service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-grupos-empresa-list',
    templateUrl: './grupos-empresa-list.component.html',
    styleUrls: ['./grupos-empresa-list.component.scss'],
    standalone: false
})
export class GruposEmpresaListComponent implements OnInit {

    @Input() empresasDisponibles: EmpresaItem[] = [];
    @Output() grupoChanged = new EventEmitter<GrupoEmpresa>();
    @Output() crearGrupo = new EventEmitter<void>();

    public grupos: GrupoEmpresa[] = [];
    public selectedGrupo: GrupoEmpresa | null = null;
    public searchText = '';

    constructor(
        private gruposEmpresaService: GruposEmpresaService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.cargarGrupos();

        this.gruposEmpresaService.recargarGrupos$.subscribe(() => {
            this.cargarGrupos();
        });
    }

    get gruposFiltrados(): GrupoEmpresa[] {
        const texto = (this.searchText || '').trim().toLowerCase();

        if (!texto) {
            return this.grupos;
        }

        return this.grupos.filter(grupo =>
            (grupo?.nombre || '').toLowerCase().includes(texto)
        );
    }

    trackByGrupoId(index: number, grupo: GrupoEmpresa): number {
        return grupo.grupoId;
    }

    cargarGrupos(): void {
        this.gruposEmpresaService.getGrupos().subscribe((response: any) => {
            if (response && response.result) {
                this.grupos = response.result;

                if (this.grupos.length > 0) {
                    const grupoSeleccionado = this.selectedGrupo
                        ? this.grupos.find(x => x.grupoId === this.selectedGrupo?.grupoId)
                        : this.grupos[0];

                    this.onSelectGrupo(grupoSeleccionado || this.grupos[0]);
                } else {
                    this.selectedGrupo = null;
                    this.grupoChanged.emit(null);
                }
            } else {
                this.grupos = [];
                this.selectedGrupo = null;
                this.grupoChanged.emit(null);
            }
        }, error => {
            console.error('Error al cargar grupos', error);
            this.grupos = [];
            this.selectedGrupo = null;
            this.grupoChanged.emit(null);
        });
    }

    onSelectGrupo(grupo: GrupoEmpresa): void {
        this.selectedGrupo = grupo;
        this.grupoChanged.emit(grupo);
    }

    addNewGrupo(): void {
        this.crearGrupo.emit();
    }

}